var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export * from './member';
export * from './link';
import { shapes } from '@joint/plus';
import { Member } from './member';
import { Link } from './link';
export var cellNamespace = __assign(__assign({}, shapes), { teamOrder: {
        Member: Member,
        Link: Link
    } });
